import { styled, Box } from '@mui/material';

export const ItemContainer = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
